'use strict';
let React = require('react');
var ReactRedux = require('react-redux');

let FooterLayout = require('../../layouts/footer').FooterLayoutComponent;
let HeaderLayout = require('../../layouts/header').HeaderLayoutComponent;
var ChatActions = require('../../../redux/chatActions');
var TwilioChat = require('twilio-chat');
const client = require('../../../../sdk/client');
var toastr = require('toastr');


class TransactionCompleteComponent extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            strInvoice : "-",
            message: "",
            number: 0
        };
    }

    componentDidMount(){
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const strInvoice = urlParams.get("strInvoice");
        const isTransfer = urlParams.get("isTransfer");
        const txnId = urlParams.get("id");
        const isQuotation = urlParams.get("isQuotation");

        //&isTransfer=false&id=triwnlf7gspf2twvypxn
        //si no existe regresaria null

        if(strInvoice != null){
            this.setState({"strInvoice" : strInvoice.split('-')[0]});
        }
        
        //Set success title text, this text only should change if quotation is enabled
        let succesTitleText = "Tu orden de compra es:";

        //spei
        if(isQuotation == 'true'){
            succesTitleText = "Tu orden de cotización es:";
            this.setState({"message" : "Recibirás un correo de confirmación sobre tu cotizacion a la brevedad. Para cualquier duda, por favor contacta a tu asesor de ventas."});
            toastr.success('Cotización creada con éxito');
        }
        else if (isTransfer == 'true' && txnId == null) {
            // this.setState({"message" : "Recibirás un correo de confirmación de compra a la brevedad. Si tienes cualquier duda, porfavor contacta a tu asesor de ventas."});
            this.setState({"message" : "Recibirás un correo de confirmación a la brevedad. Recuerda que cuentas con 24 horas para concretar el pago, de lo contrario el pedido será cancelado de forma automática. Para cualquier duda, por favor contacta a tu asesor de ventas."});
          //  console.log('Actualizar pago con spei');
            //toastr.success('Pago Exitoso');
            //esto se actualiza bien con el hook
        } else if (isTransfer == 'false' && txnId != null) {
            this.setState({"message" : "Recibirás un correo de confirmación a la brevedad. Revisa tu aplicación de banco en caso de que tengas que aceptar el cargo. Para cualquier duda, por favor contacta a tu asesor de ventas."});
          //  console.log('paso pago con tarjeta redirect')
            //this.CardProcess(strInvoice, txnId);           
        }
        else {
            //linea de credito
            this.setState({"message" : "Recibirás un correo de confirmación a la brevedad. Para cualquier duda, por favor contacta a tu asesor de ventas."});
           // console.log('Esto es para linea de credito');
            toastr.success('Pago Exitoso');
            //this.Credit(strInvoice);
        }

        //Set Text to display (span element)
        $('#succesTitleText').text(succesTitleText);

        const options = {
			pluginId: process.env.OPENPAY,
			tableName: "SucceedRegisteredOrders",
            query: [{
                Name: "PurchaseOrder",
                Operator: "equal",
                Value: strInvoice.split('-')[0]
            }]
		};
			
		client.CustomTables.searchCustomTable(options, function (err, result) {
            console.log("result");
            console.log(result);
			if (result.TotalRecords > 0) {
                var res = result.Records[0];
			    console.log("res");
			    console.log(res);
                var seen = res.seen;
				if(seen == 0) {
                    let options = {
                        rowID: res.Id, //ID creado en. la tabla de succeed orders
                        pluginId: process.env.OPENPAY,
                        tableName: 'SucceedRegisteredOrders',
                        request: {
                            seen: 1
                        }
                    };

                    client.CustomTables.updateCustomTableRow(options, function (err, result) {
                        console.log("seen = 0");
                        window.gtag("event", "purchase", {
                            'app_name': 'Megamak'
                        });
                    });
                } else {
                    let options = {
                        rowID: res.Id,
                        pluginId: process.env.OPENPAY,
                        tableName: 'SucceedRegisteredOrders',
                        request: {
                            seen: 1
                        }
                    };

                    client.CustomTables.updateCustomTableRow(options, function (err, result) {
                        console.log(result);
                        window.location.href = 'https://' + process.env.BASE_URL;
                    });
                }
            } else {
                console.log("else");
                window.location.href = 'https://' + process.env.BASE_URL;
            }
		});
}

    Credit(folio){
        let request = {
            "type": "charge.succeeded",
            "transaction": {
                "status": "completed",
                "description": "Cargo con linea de credito",
                "order_id": folio,
                "method": "creditLine"
            }
        }

        const promiseopenPayWebhook = client.Arcadier.OpenPayWebhook(request);

        promiseopenPayWebhook.then(response => {
            console.log('llego el hook')
            console.log(response)
        });


    }

    CardProcess(strInvoice, txnId) {
        console.log('Actualizar pago con tarjeta');
        //esto deberia llegar bien una vez tratar obtener con el id la info de openpay

        const promiseGetTransactionInfo = client.OpenPay.GetTransaction(txnId);

        const promiseGetInvoiceDetail = new Promise((resolve, reject) => {
            let options = {
                invoiceNo: strInvoice,
            };

            client.Orders.getInvoiceNumberDetails(options, function (err, result) {
                resolve(result);
            });
        });

        Promise.all([promiseGetInvoiceDetail, promiseGetTransactionInfo]).then(responses => {
            let invoiceDetails = responses[0];
            let txnInfo = responses[1];

            let merchantId = invoiceDetails.Orders[0].MerchantDetail.ID;
            let orderId = invoiceDetails.Orders[0].ID;
            let payee = merchantId;
			let payer = invoiceDetails.Orders[0].ConsumerDetail.ID;

            if (txnInfo.status == "completed") {
                console.log(txnInfo);
                toastr.success('Pago Existoso')
                const promiseUpdateOrder = new Promise((resolve, reject) => {
                    let options = {
                        userId: merchantId,
                        orderId: orderId,
                        balance: 0,
                        fulfilmentStatus: "Acknowledged",
                        paymentStatus: "Paid",
                        customFields: null
                    };

                    client.Orders.updateMerchantOrder(options, function (err, result) {
                        resolve(result);
                    });
                });

                promiseUpdateOrder.then(updatedOrder => {

                    const promiseUpdateInvoice = new Promise((resolve, reject) => {
                        let options = {
                            invoiceNo: strInvoice,
                            status: "Success",
                            userId: merchantId
                        };

                        client.Invoices.updateInvoiceStatus(options, function (err, result) {
                            resolve(result);
                        });
                    });

                    promiseUpdateInvoice.then(response => {
                        console.log(response)

                        const promiseUpdatePaymentDetails = new Promise((resolve, reject) => {
                            let requestUpdatePayment = {
                                orderId: orderId,
                                payerId: payer,
                                payeeId: payee,
                                invoiceNo: strInvoice,
                                status: "Success",
                                // gatewayCode: selectedGatewayCode ,
                                // payKey: response.id,
                                // transactionId: response.id,
                                // gatewayTimestamp: response.creation_date,
                                gatewayStatus: txnInfo.status,
                                // gatewayReceiverId: "",
                                // gatewaySenderId: "",
                                // gatewayRef: "",
                                isMerchantOnly: true
                            };

                            client.Payments.updatePaymentDetails(requestUpdatePayment, function (err, result) {
                                resolve(result);
                            });
                        });

                        promiseUpdatePaymentDetails.then(updatedPayment => {
                            console.log(updatedPayment)
                        }, error => {
                            console.log(error)
                        });

                    }, (error) => {
                        console.log(error)
                    })


                }, error => {
                    console.log(error)
                });

            } else {
                console.log('No es success el pago ver que hacer');
            }


        }, error => {
            console.log(error)
        });

    }

    render() {
        let isRegistered = "";
        let isGuest = "hide";
        if (this.props.user != null && this.props.user.Guest == false) {
            isRegistered = "hide"
            isGuest = "";
        }

        let urlAction = "/accounts/non-private/sign-in";

        return (
            <React.Fragment>
                <div className="header mod" id="header-section">
                    <HeaderLayout categories={this.props.categories} user={this.props.user} />
                </div>
                <div className="main">
                    <div className="transaction-complete-container">
                        <div className="container">
                            <div className="bp-trss-content">
                                <div className="bp-trss-top">
                                    <span>Transacción exitosa</span>
                                </div>
                                <div className="bp-trss-body">
                                    <span id='succesTitleText'>-</span>
                                    <span >{this.state.strInvoice}</span>
                                    <span className="span-margin">{this.state.message}</span>
                                    <div className={"bp-trss-btn " + isGuest}>
                                        <div className="btn-green"><a href="/purchase/history">Historial de compra</a></div>
                                        <div className="btn-red"><a href="/">Regresar a inicio</a></div>
                                    </div>
                                    <div className={"bp-trss-btn " + isRegistered}>
                                        <div className="btn-green">¡Regístrese ahora para guardar su dirección para la próxima vez!</div>
                                        <div className="btn-red"><a href={urlAction}>¡Quiero Registrarme!    </a></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer" id="footer-section">
                    <FooterLayout panels={this.props.panels} />
                </div>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        user: state.settingsReducer.user,
        invoiceDetails: state.settingsReducer.invoiceDetails,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getOfferByCartItemId: (cartItemId, callback) => dispatch(ChatActions.getOfferByCartItemId(cartItemId, callback)),
        acceptOffer: (options, callback) => dispatch(ChatActions.acceptOffer(options, callback))
    }
}

const TransactionCompletePage = ReactRedux.connect(
    mapStateToProps,
    mapDispatchToProps
)(TransactionCompleteComponent)

module.exports = {
    TransactionCompletePage,
    TransactionCompleteComponent
}